import React, { useState } from 'react';
import ContactServices from './../../services/ContactServices';
import Swal from 'sweetalert2'
import cluo from '../../assets/images/contacto/cluo.png';

const Formulario_oportunidades = () => {
  const [formData, setFormData] = useState({
    contacto: '',
    nombreCompleto: '',
    descripcion: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    
    // Limpiar error del campo cuando el usuario empiece a escribir
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.contacto.trim()) {
      newErrors.contacto = 'El correo electrónico es requerido';
    } else if (!/\S+@\S+\.\S+/.test(formData.contacto)) {
      newErrors.contacto = 'El formato del correo electrónico no es válido';
    }
    
    if (!formData.nombreCompleto.trim()) {
      newErrors.nombreCompleto = 'Los nombres y apellidos son requeridos';
    }
    
    if (!formData.descripcion.trim()) {
      newErrors.descripcion = 'La descripción es requerida';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    // Adaptamos los datos al formato que espera el API de oportunidades
    const dataForAPI = {
      Nombres: formData.nombreCompleto,
      Telefono: 999999999, // Valor por defecto para postulaciones sin teléfono
      Email: formData.contacto,
      Mensaje: `POSTULACIÓN LABORAL - VÍA WEB

Candidato: ${formData.nombreCompleto}
Email: ${formData.contacto}

Descripción/Presentación:
${formData.descripcion}

---
Nota: Esta postulación fue enviada desde el formulario web de oportunidades laborales.`
    };

    console.log('=== DATOS ADAPTADOS PARA API DE OPORTUNIDADES ===');
    console.log('Datos originales:', formData);
    console.log('Datos para API:', dataForAPI);

    try {
      await sendOpportunityEmail(dataForAPI);
      
      // Limpiar formulario después del envío exitoso
      setFormData({
        contacto: '',
        nombreCompleto: '',
        descripcion: '',
      });
      setErrors({});
      
    } catch (error) {
      console.error('Error al enviar:', error);
    }
  };

  // Función específica para envío de oportunidades
  const sendOpportunityEmail = async (userdata) => {
    console.log("=== INICIANDO ENVÍO DE EMAIL DE OPORTUNIDADES ===");
    console.log("Datos a enviar:", userdata);
    
    try {
      // SOLUCIÓN TEMPORAL: Usar el endpoint de contacto que funciona
      // TODO: Cambiar a sendOpportunityEmail cuando el endpoint esté configurado
      const response = await ContactServices.sendOpportunityEmail(userdata);
      
      console.log("=== RESPUESTA COMPLETA DE OPORTUNIDADES ===");
      console.log("response:", response);
      console.log("response.status:", response.status);
      console.log("response.statusText:", response.statusText);
      console.log("response.data:", response.data);
      console.log("Tipo de response.data:", typeof response.data);
      
      // Verificar si response.data es string (necesita parsing)
      let parsedData;
      if (typeof response.data === 'string') {
        try {
          parsedData = JSON.parse(response.data);
          console.log("Data parseada:", parsedData);
        } catch (e) {
          console.log("Error parseando JSON:", e);
          parsedData = response.data;
        }
      } else {
        parsedData = response.data;
      }
      
      console.log("=== VALIDACIÓN DE ESTRUCTURA ===");
      console.log("¿Tiene statusCode?", "statusCode" in parsedData);
      console.log("parsedData.statusCode:", parsedData.statusCode);
      console.log("¿Tiene body?", "body" in parsedData);
      
      // Si tiene body, intentar parsearlo también
      if (parsedData.body) {
        try {
          const bodyParsed = JSON.parse(parsedData.body);
          console.log("Body parseado:", bodyParsed);
          console.log("¿Body tiene statusCode?", "statusCode" in bodyParsed);
          console.log("bodyParsed.statusCode:", bodyParsed.statusCode);
          console.log("bodyParsed.message:", bodyParsed.message);
          
          // Usar los datos del body parseado
          if (bodyParsed.statusCode === 200) {
            console.log("✅ ÉXITO - Usando body parseado");
            Swal.fire({
              imageUrl: cluo,
              title: "¡Postulación enviada exitosamente!",
              text: "Gracias por tu interés. Nos pondremos en contacto contigo pronto.",
              confirmButtonColor: '#c74634',
            });
            return;
          } else {
            console.log("❌ ERROR - StatusCode del body no es 200");
            Swal.fire({
              imageUrl: cluo,
              title: bodyParsed.message || "Error al enviar postulación",
              confirmButtonColor: '#c74634',
            });
            return;
          }
        } catch (e) {
          console.log("Error parseando body:", e);
        }
      }
      
      // Verificar statusCode directo
      if (parsedData.statusCode === 200) {
        console.log("✅ ÉXITO - StatusCode directo es 200");
        Swal.fire({
          imageUrl: cluo,
          title: "¡Postulación enviada exitosamente!",
          text: "Gracias por tu interés. Nos pondremos en contacto contigo pronto.",
          confirmButtonColor: '#c74634',
        });
      } else if (parsedData.statusCode) {
        console.log("❌ ERROR - StatusCode no es 200:", parsedData.statusCode);
        Swal.fire({
          imageUrl: cluo,
          title: parsedData.message || "Error al enviar postulación",
          confirmButtonColor: '#c74634',
        });
      } else {
        console.log("❌ ERROR - No se encontró statusCode");
        console.log("Estructura de datos:", Object.keys(parsedData));
        Swal.fire({
          imageUrl: cluo,
          title: "Lo sentimos, no logramos enviar la postulación",
          confirmButtonColor: '#c74634',
        });
      }
      
    } catch (error) {
      console.log("=== ERROR EN CATCH DE OPORTUNIDADES ===");
      console.log("Error completo:", error);
      console.log("Error message:", error.message);
      console.log("Error response:", error.response);
      
      if (error.response) {
        console.log("Error response status:", error.response.status);
        console.log("Error response data:", error.response.data);
      }
      
      Swal.fire({
        imageUrl: cluo,
        title: "Lo sentimos, no logramos enviar la postulación",
        text: "Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: '#c74634',
      });
      
      throw error; // Re-lanzar el error para que el handleSubmit lo capture
    }
  };

  return (
    <div style={styles.wrapper}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>
          Correo electrónico:
          <input
            type="email"
            name="contacto"
            value={formData.contacto}
            onChange={handleChange}
            required
            style={{
              ...styles.input,
              borderColor: errors.contacto ? '#ff0000' : '#ccc'
            }}
          />
          {errors.contacto && (
            <span style={styles.error}>{errors.contacto}</span>
          )}
        </label>

        <label style={styles.label}>
          Nombres y Apellidos:
          <input
            type="text"
            name="nombreCompleto"
            value={formData.nombreCompleto}
            onChange={handleChange}
            required
            style={{
              ...styles.input,
              borderColor: errors.nombreCompleto ? '#ff0000' : '#ccc'
            }}
          />
          {errors.nombreCompleto && (
            <span style={styles.error}>{errors.nombreCompleto}</span>
          )}
        </label>

        <label style={styles.label}>
          Descripción / Presentación:
          <textarea
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            placeholder="Cuéntanos sobre tu experiencia, habilidades y por qué te interesa trabajar en Manantial..."
            required
            style={{
              ...styles.textarea,
              borderColor: errors.descripcion ? '#ff0000' : '#ccc'
            }}
          />
          {errors.descripcion && (
            <span style={styles.error}>{errors.descripcion}</span>
          )}
        </label>

        <button type="submit" style={styles.button}>
          ENVIAR POSTULACIÓN
        </button>
      </form>
    </div>
  );
};

const styles = {
  wrapper: {
    backgroundColor: '#232F3E', 
    padding: '30px',
    maxWidth: '500px',
    margin: '40px auto',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    minHeight: '400px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    margin: '0 auto',
    gap: '1rem',
    fontFamily: 'Sora, sans-serif' 
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '16px',
    fontFamily: 'Sora, sans-serif',
    color: '#fff',
    marginBottom: '15px',
    marginTop: '8px'
  },
  input: {
    padding: '10px',
    fontSize: '14px',
    fontFamily: 'Sora, sans-serif',
    marginTop: '15px',
    border: '1px solid #ccc',
    borderRadius: '4px'
  },
  textarea: {
    padding: '8px',
    fontSize: '14px',
    resize: 'vertical',
    minHeight: '80px',
    fontFamily: 'Sora, sans-serif',
    marginTop: '15px',
    border: '1px solid #ccc',
    borderRadius: '4px'
  },
  button: {
    padding: '10px',
    fontSize: '16px',
    backgroundColor: '#c74634',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontFamily: 'Sora-Bold, sans-serif',
    marginBottom: '15px',
    '&:hover': {
      backgroundColor: '#a63929'
    }
  },
  error: {
    color: '#ff6b6b',
    fontSize: '12px',
    marginTop: '5px',
    fontFamily: 'Sora, sans-serif'
  }
};

export default Formulario_oportunidades;